module.exports = __webpack_public_path__ + "440c1e309b817c5f188ba5b9eecd15e6.svg";